import { Flex } from "antd";
import styles from "./index.module.less";
import p3Card1Icon1 from "./imgs/ip_icon1.svg";
import p3Card2Icon1 from "./imgs/ip_icon2.png";
import p3Card2Icon2 from "./imgs/ip_icon3.png";
import p3Card3Icon1 from "./imgs/ip_icon4.svg";
import p3img1 from "./imgs/p3_img1.png";
import p3img2 from "./imgs/p3_img2.png";
import p3img3 from "./imgs/p3_img3.png";
import p3Img4 from "./imgs/p3_img4.png";
import p3img5 from "./imgs/p3_img5.png";
import p3img6 from "./imgs/p3_img6.png";
import p2Img from "./imgs/p2_img.png";
import P1Content from "@/components/P1Content";
import data from "../data";
import banner from "./imgs/p1_bg.png";

const iconMap = {
  p3Card1Icon1,
  p3Card2Icon1,
  p3Card2Icon2,
  p3Card3Icon1,
};
const imgMap = {
  p3img1,
  p3img2,
  p3img3,
  p3Img4,
  p3img5,
  p3img6,
  p2Img,
};

const P3Card = ({
  title,
  desc,
  icons,
  index,
  imgs,
}: {
  title: string;
  desc: any;
  icons: string[];
  index: number;
  imgs?: string[];
}) => {
  return (
    <div className={styles.p3Card}>
      <div className={styles.p3CardRight}>
        <div className={styles.p3CardLeft}>
          {imgs && imgs.length === 1 ? (
            <img src={imgMap[imgs[0] as keyof typeof imgMap]} style={{
                width: "100%",
            }} />
          ) : imgs && imgs.length > 1 ? (
            <Flex gap={".08rem"}>
              <img src={imgMap[imgs[0] as keyof typeof imgMap]} style={{
                    width: "1.63rem",
              }} />
              <Flex vertical gap={".08rem"}>
                {imgs.slice(1).map((img, i) => (
                  <img key={i} src={imgMap[img as keyof typeof imgMap]} style={{
                        width: "1.63rem",
                  }} />
                ))}
              </Flex>
            </Flex>
          ) : null}
        </div>
        <Flex vertical gap={'.08rem'}>
        <div className={styles.p3CardIndex}>0{index}</div>
        <div className={styles.p3CardTitle}>{title}</div>
        <div className={styles.p3CardDesc}>
          {Array.isArray(desc)
            ? desc.map((d, i) =>
                d.strong ? (
                  <div key={i} style={{ color: "#16171A", fontWeight: 500 }}>
                    {d.text}
                  </div>
                ) : (
                  <div key={i}>{d.text}</div>
                )
              )
            : desc}
        </div></Flex>
      </div>
    </div>
  );
};
const MobileInteractiveIP = () => {
  return (
    <div>
      <div className={styles.p1}>
        <P1Content
          title={data.p1.title}
          subtitle={data.p1.subtitle}
          style={{
            backgroundImage: `url(${banner})`,
          }}
        />
      </div>
      <div className={styles.p2}>
        <div className={styles.p2_inner}>
          <Flex vertical gap={".36rem"}>
            <div className={styles.p2_title}>{data.p2.title}</div>
            <img
              src={imgMap[data.p2.img as keyof typeof imgMap]}
              className={styles.p2_img}
            />
            <div className={styles.p2_desc}>{data.p2.desc}</div>
          </Flex>
        </div>
      </div>
      <div className={styles.p3}>
        <div className={styles.p3_inner}>
          <div className={styles.p3_title}>{data.p3.title}</div>
          {data.p3.cases.map((item, index) => (
            <P3Card key={index} {...item} index={index + 1} />
          ))}
        </div>
      </div>
    </div>
  );
};
export default MobileInteractiveIP;
